import { userService } from './../../../Services/userService';
import { RenewBindMdl } from './../../../Models/RenewBindMdl';
import { MotorproposalTrackingService } from './../../../Services/MotorproposalTrackingService';
import { renewalProposalService } from './../../../Services/renewalProposalService';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { TPLProposal } from '../../../Models/TPLProposal';
import { BindMdl } from '../../../Models/BindMdl';
import { restURL } from '../../../Models/restURL';
import { tplCoversPipe } from '../../../Pipes/tplCoversPipe';
import { tplManCovers } from '../../../Pipes/tplManCovers';
import { LanguageService } from '../../../Services/languageService';
import { mdlPremiumAndVehicleInfoCompRenewalRes } from '../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes';
import { mdlPremiumMainCoversCompRenewal } from '../../../Models/mdlPremiumMainCoversCompRenewal';
import * as html2canvas from 'html2canvas';
import { mdlCalculatePremiumCompRenewalReq } from '../../../Models/mdlCalculatePremiumCompRenewalReq';
import { mdlBindInfoCompRenewalRes } from '../../../Models/mdlBindInfoCompRenewalRes';
import { mdlPreminumDetailsCompRenewal } from '../../../Models/mdlPreminumDetailsCompRenewal';
import { mdlCheckPromoCodeReq } from '../../../Models/mdlCheckPromoCodeReq';
import { mdlCheckPromoCodeRes } from '../../../Models/mdlCheckPromoCodeRes';
import Swal from 'sweetalert2';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
@Component({
  selector: 'CompRenewalPremiumInfo',
  templateUrl: './CompRenewalPremiumInfo.html',
  styleUrls: ['./CompRenewalPremiumInfo.css']
})
export class CompRenewalPremiumInfo {

  public prObj: TPLProposal = new TPLProposal();
  public preObj: TPLProposal = new TPLProposal();
  public bindObj: RenewBindMdl = new RenewBindMdl();
  public subscription: Subscription;
  public bindSubscription: Subscription;
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public Lng: string;
  public objPremiumAndVehicleInfoRes: mdlPremiumAndVehicleInfoCompRenewalRes = new mdlPremiumAndVehicleInfoCompRenewalRes();

  public BASIC: number; public ADMIN_FEE: number; public NCD_PER: number; public NCD_AMOUNT: number;
  public LD_PER: number; public LD_AMOUNT: number; public AGE_LOADING: number; public CLAIM_LOADING: number;
  public GROSS_AMOUNT: number; public TOTAL_EXC_VAT: number; public VAT_AMOUNT: number;
  public TOTAL_PREMIUM: number; public PAB: number; public DAB: number; public CAL: number;
  public BAHRAIN: number; public Geographical_Inc_Bahrain: number; public Geographical_EJL: number;
  public ZERO_DEP: number; public promocode: string; public VEHICLE_REP: number;
  public UPR_VAT_AMOUNT: number; public PROMO_DISC_PER: number; public PROMO_DISC_AMOUNT: number;
  public DRIVER_DISC_PER: number; public DRIVER_DISC_AMOUNT: number;
  public OTHER_DISC_PER: number; 
  public OTHER_DISC_AMOUNT: number;


  public CoverDetails: mdlPremiumMainCoversCompRenewal = new mdlPremiumMainCoversCompRenewal();
  public objmdlCheckPromoCodeReq: mdlCheckPromoCodeReq = new mdlCheckPromoCodeReq();
  public objBindInfoRes: mdlBindInfoCompRenewalRes = new mdlBindInfoCompRenewalRes();
  public objmdlCheckPromoCodeRes: mdlCheckPromoCodeRes = new mdlCheckPromoCodeRes();
  public objCalculatePremiumWithPromoRes: mdlPreminumDetailsCompRenewal = new mdlPreminumDetailsCompRenewal();
  public objmdlCalculatePremiumCompRenewalReq: mdlCalculatePremiumCompRenewalReq = new mdlCalculatePremiumCompRenewalReq();
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();


  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private lngService: LanguageService, private trackingObj: MotorproposalTrackingService, private userinfo: userService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }

    //this.objPremiumAndVehicleInfoRes = JSON.parse(sessionStorage.getItem("objPremiumAndVehicleInfoRes"));
    this.objPremiumAndVehicleInfoRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objPremiumAndVehicleInfoRes")));
   
    //this.objBindInfoRes = JSON.parse(sessionStorage.getItem("objBindInfoRes"));
    this.objBindInfoRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objBindInfoRes")));
    this.isShowLoading = false;
    this.CalculatePremium();
  }


  CalculatePremium() {
    this.BASIC = 0; this.ADMIN_FEE = 0; this.NCD_AMOUNT = 0;
    this.LD_AMOUNT = 0; this.GROSS_AMOUNT = 0; this.TOTAL_EXC_VAT = 0;
    this.VAT_AMOUNT = 0; this.TOTAL_PREMIUM = 0; this.PROMO_DISC_AMOUNT = 0;
    this.UPR_VAT_AMOUNT = 0; this.NCD_PER = 0; this.LD_PER = 0; this.PROMO_DISC_PER = 0;
    this.DRIVER_DISC_PER = 0;
    this.PAB = 0; this.DAB = 0; this.CAL = 0; this.PROMO_DISC_PER = 0;
    this.PROMO_DISC_AMOUNT = 0; this.DRIVER_DISC_PER = 0; this.DRIVER_DISC_AMOUNT = 0
    this.BAHRAIN = 0; this.AGE_LOADING = 0; this.Geographical_Inc_Bahrain = 0;
    this.Geographical_EJL = 0; this.ZERO_DEP = 0; this.VEHICLE_REP = 0;
    this.CLAIM_LOADING = 0; this.AGE_LOADING = 0;
    this.OTHER_DISC_PER=0;
    this.OTHER_DISC_AMOUNT=0;



    let objAllcovers: Array<mdlPremiumMainCoversCompRenewal> = new Array<mdlPremiumMainCoversCompRenewal>();
    let objFinalcovers: Array<mdlPremiumMainCoversCompRenewal> = new Array<mdlPremiumMainCoversCompRenewal>();
    let objBasicCover: mdlPremiumMainCoversCompRenewal = new mdlPremiumMainCoversCompRenewal;
    let objAdminCover: mdlPremiumMainCoversCompRenewal = new mdlPremiumMainCoversCompRenewal;
    objAllcovers = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails;
    objBasicCover = objAllcovers.filter(Z => Z.CoverCode == "552001"|| Z.CoverCode == "551501")[0];
    objAdminCover = objAllcovers.filter(Z => Z.CoverCode == "552007" || Z.CoverCode == "551504")[0];
    this.UPR_VAT_AMOUNT = this.objPremiumAndVehicleInfoRes.POLICY_INFO.UPR_VAT_AMOUNT;

    this.BASIC = objBasicCover.GrossAmount;
    this.ADMIN_FEE = objAdminCover.GrossAmount;
    this.NCD_PER = objBasicCover.NCDPercent;
    this.NCD_AMOUNT = objBasicCover.NCDAmount;
    this.LD_PER = objBasicCover.LDPercent;
    this.LD_AMOUNT = objBasicCover.LDAmount;
    this.PROMO_DISC_PER = objBasicCover.PromoDiscPer;
    this.DRIVER_DISC_PER = objBasicCover.DriverDiscPer;
    this.OTHER_DISC_PER=objBasicCover.UserDiscPer+objBasicCover.OtherDiscPer;


    for (let cover of objAllcovers) {
      this.GROSS_AMOUNT = cover.GrossAmount + this.GROSS_AMOUNT;
      this.TOTAL_EXC_VAT = cover.TotalPrice + this.TOTAL_EXC_VAT;
      this.VAT_AMOUNT = cover.Vat_Amount + this.VAT_AMOUNT;
      this.PROMO_DISC_AMOUNT = cover.PromoDiscAmount + this.PROMO_DISC_AMOUNT;
      this.DRIVER_DISC_AMOUNT = cover.DriverDiscAmount + this.DRIVER_DISC_AMOUNT;
      this.OTHER_DISC_AMOUNT= cover.UserDiscount + this.OTHER_DISC_AMOUNT;

      if (cover.CoverCode == "552006" || cover.CoverCode ==  "551502") {
        this.PAB = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552006" || Z.CoverCode == "551502" )[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552005" || cover.CoverCode =="551503") {
        this.DAB = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552005" || Z.CoverCode == "551503")[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552008") {
        this.BAHRAIN = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552008")[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552009") {
        this.Geographical_Inc_Bahrain = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552009")[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552010") {
        this.Geographical_EJL = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552010")[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552011") {
        this.ZERO_DEP = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552011")[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552012") {
        this.VEHICLE_REP = cover.GrossAmount;
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552012")[0].IsMandatory = true;
      }
      if (cover.CoverCode == "552013" || cover.CoverCode =="551508") {
        this.CLAIM_LOADING = cover.GrossAmount;
      }
      if (cover.CoverCode == "552014" || cover.CoverCode =="551507") {
        this.AGE_LOADING = cover.GrossAmount;
      }

    }

    this.TOTAL_PREMIUM = this.TOTAL_EXC_VAT + this.VAT_AMOUNT + this.UPR_VAT_AMOUNT;

  }

  AdditionalCoversCheck(e, Benifit) {
 
    let isChecked: boolean
    isChecked = e.target.checked;
    if (isChecked) {
      this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails.push(
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0]
      )
      this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].IsMandatory = true;


      ///<<<<<<<<<DAB START>>>>>>>>>>>>>>>>
      if (Benifit == "552005" || Benifit == "551503") {
        this.DAB = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;

      }
      ///<<<<<<<<<DAB END>>>>>>>>>>>>>>>>
      ///<<<<<<<<<PAB START>>>>>>>>>>>>>>>>
      if (Benifit == "552006"|| Benifit == "551502") {
       
        this.PAB = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
        if (this.DAB == 0) {
          this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails.push(
            this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552005" || Z.CoverCode == "551503" )[0]  );
          this.DAB = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552005" || Z.CoverCode == "551503")[0].TotalPrice;
       
          this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == "552005" || Z.CoverCode == "551503")[0].IsMandatory = true;
        }
      }
      ///<<<<<<<<<PAB END>>>>>>>>>>>>>>>>
      ///<<<<<<<<Comp additional loading due to accidents START>>>>>>>>
      if (Benifit == "552013") {
        this.CAL = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<Comp additional loading due to accidents END>>>>>>>>
      ///<<<<<<<<BAHRAIN ONLY  START>>>>>>>>
      if (Benifit == "552008") {
        this.BAHRAIN = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<BAHRAIN ONLY END>>>>>>>>
      ///<<<<<<<<Age Loading  START>>>>>>>>
      if (Benifit == "552014") {
        this.AGE_LOADING = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<Age Loading END>>>>>>>>

      ///<<<<<<<<Geographical including bahrain  START>>>>>>>>
      if (Benifit == "552009") {
        this.Geographical_Inc_Bahrain = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<Geographical including bahrain END>>>>>>>>

      ///<<<<<<<<Geographical Egypt,jordan   START>>>>>>>>
      if (Benifit == "552010") {
        this.Geographical_EJL = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<Geographical Egypt,jordan END>>>>>>>>

      ///<<<<<<<<Zero deprecation   START>>>>>>>>
      if (Benifit == "552011") {
        this.ZERO_DEP = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<Zero deprecation END>>>>>>>>

      ///<<<<<<<<Replacement vehicle   START>>>>>>>>
      if (Benifit == "552012") {
        this.VEHICLE_REP = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].TotalPrice;
      }
      ///<<<<<<<<Replacement vehicle END>>>>>>>>
      this.CalculatePremium();
    }
    else {
      if ((Benifit == "552005" || Benifit == "551503")  && this.PAB != 0) {
        swal("DAB Is Mandatory If PAB Selected");
        this.AdditionalCoversCheck(e.target.checked = true, Benifit);
        return;
      }
      this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails.splice(this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails.findIndex(Z => Z.CoverCode == Benifit), 1);
      this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers.filter(Z => Z.CoverCode == Benifit)[0].IsMandatory = false;

      ///<<<<<<<<<DAB START>>>>>>>>>>>>>>>>
      if (Benifit == "552005" || Benifit == "551503") {
        this.DAB = 0;
      }
      ///<<<<<<<<<DAB END>>>>>>>>>>>>>>>>
      ///<<<<<<<<<PAB START>>>>>>>>>>>>>>>>
      if (Benifit == "552006" || Benifit == "551502") {
        this.PAB = 0;
      }
      ///<<<<<<<<<PAB END>>>>>>>>>>>>>>>>
      ///<<<<<<<<Comp additional loading due to accidents START>>>>>>>>
      if (Benifit == "552013") {
        this.CAL = 0;
      }
      ///<<<<<<<<Comp additional loading due to accidents END>>>>>>>>
      ///<<<<<<<<BAHRAIN ONLY  START>>>>>>>>
      if (Benifit == "552008") {
        this.BAHRAIN = 0;
      }
      ///<<<<<<<<BAHRAIN ONLY END>>>>>>>>
      ///<<<<<<<<Age Loading  START>>>>>>>>
      if (Benifit == "552014") {
        this.AGE_LOADING = 0;
      }
      ///<<<<<<<<Age Loading END>>>>>>>>

      ///<<<<<<<<Geographical including bahrain  START>>>>>>>>
      if (Benifit == "552009") {
        this.Geographical_Inc_Bahrain = 0;
      }
      ///<<<<<<<<Geographical including bahrain END>>>>>>>>

      ///<<<<<<<<Geographical Egypt,jordan   START>>>>>>>>
      if (Benifit == "552010") {
        this.Geographical_EJL = 0;
      }
      ///<<<<<<<<Geographical Egypt,jordan END>>>>>>>>

      ///<<<<<<<<Zero deprecation   START>>>>>>>>
      if (Benifit == "552011") {
        this.ZERO_DEP = 0;
      }
      ///<<<<<<<<Zero deprecation END>>>>>>>>

      ///<<<<<<<<Replacement vehicle   START>>>>>>>>
      if (Benifit == "552012") {
        this.VEHICLE_REP = 0;
      }
      ///<<<<<<<<Replacement vehicle END>>>>>>>>

      this.CalculatePremium();
    }





  }


  goNext() {

    html2canvas(document.body).then(canvas => {
      var imgData = canvas.toDataURL("image/png");
      sessionStorage.setItem("ScreenShot", imgData);
    });
    //sessionStorage.setItem("objPremiumAndVehicleInfoRes", JSON.stringify(this.objPremiumAndVehicleInfoRes));
    sessionStorage.setItem("objPremiumAndVehicleInfoRes", this.EncriptService.EncriptObject(JSON.stringify(this.objPremiumAndVehicleInfoRes)));
    this.router.navigate(['NewDashboard/CompRenewalProposal/CompRenewalReviewConfirm']);
  }

  Prev() {
    this.router.navigate(['NewDashboard/CompRenewalPolicy']);
  }

  CheckPromoCode(val) {
    if (val == "" || val == null || val == undefined) {
      swal("Please Enter a PromoCode.");
      return;
    } else {
      
      this.objmdlCheckPromoCodeReq.Insured_IdNo = this.objBindInfoRes.Insured_IdNo;
      this.objmdlCheckPromoCodeReq.SequenceNo = this.objBindInfoRes.SequenceNo;
      this.objmdlCheckPromoCodeReq.PromoCode = val;
      this.objmdlCheckPromoCodeReq.ProductCode = this.objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode;
      this.objmdlCheckPromoCodeReq.ChassisNo = "";
      this.objmdlCheckPromoCodeReq.CustomId = "";
      this.isShowLoading = true;

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlCheckPromoCodeReq));

      //this.http.post<mdlCheckPromoCodeRes>(this.url.baseURL + "/Comp_Renewal/PromoCheck", this.objmdlCheckPromoCodeReq, this.userinfo.getHttpOptions())
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Comp_Renewal/PromoCheck", this.objPayloadRequest, this.userinfo.getHttpOptions())
        .toPromise().then((result) => {
          // this.objmdlCheckPromoCodeRes = result;

          //New Line Start
          this.objPayloadResponse = result;
          this.objmdlCheckPromoCodeRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
          //NewLine End

          if (this.objmdlCheckPromoCodeRes.StatusCode == "1") {
            if (this.objmdlCheckPromoCodeRes.PromoResult == "1") {
              this.CalculatePremiumWithPromo();

            } else {
              this.isShowLoading = false;
              swal("InValid Promo Code/Promo Code Expired");
              this.promocode = "";
            }
          } else {
            swal(this.objmdlCheckPromoCodeRes.ErrorMsg);
          }


        },
          (error) => {
            this.isShowLoading = false;
          });
    }
  }

  CalculatePremiumWithPromo() {

    this.objmdlCalculatePremiumCompRenewalReq.PolicyNo = this.objPremiumAndVehicleInfoRes.POLICY_INFO.POLICYNO;
    this.objmdlCalculatePremiumCompRenewalReq.DriverNCDDetails = this.objPremiumAndVehicleInfoRes.DRIVER_INFO;
    this.objmdlCalculatePremiumCompRenewalReq.DeductableType = this.objBindInfoRes.DeductableType;
    this.objmdlCalculatePremiumCompRenewalReq.RepairType = this.objBindInfoRes.RepairType;
    this.objmdlCalculatePremiumCompRenewalReq.SumInsured = this.objBindInfoRes.SumInsured;
    this.objmdlCalculatePremiumCompRenewalReq.CoverDetails = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails;
    this.objmdlCalculatePremiumCompRenewalReq.PromoDiscPer = this.objmdlCheckPromoCodeRes.PromoDiscPer;
    this.objmdlCalculatePremiumCompRenewalReq.PromoId = this.objmdlCheckPromoCodeRes.PromoId;
    this.objmdlCalculatePremiumCompRenewalReq.PromoCode = this.objmdlCheckPromoCodeRes.PromoCode;
    this.objmdlCalculatePremiumCompRenewalReq.PromoDiscountType = this.objmdlCheckPromoCodeRes.PromoDiscountType;
    this.objmdlCalculatePremiumCompRenewalReq.PromoDiscFlatAmount = this.objmdlCheckPromoCodeRes.PromoDiscFlatAmount;
    
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlCalculatePremiumCompRenewalReq));

    //this.http.post<mdlPreminumDetailsCompRenewal>(this.url.baseURL + "/Comp_Renewal/CalculatePremiumCompRenewal", this.objmdlCalculatePremiumCompRenewalReq, this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Comp_Renewal/CalculatePremiumCompRenewal", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.isShowLoading = false;
        //this.objCalculatePremiumWithPromoRes = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.objCalculatePremiumWithPromoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End

        this.promocode = "";
      
        this.objPremiumAndVehicleInfoRes.PREMIUM_INFO = this.objCalculatePremiumWithPromoRes;
        this.CalculatePremium();
        if (this.PROMO_DISC_AMOUNT > 0) {
          Swal("PromoCode Applied Successfully");
        }
      },
        (error) => {
          this.isShowLoading = false;
          this.userinfo.checkTokenStatus(error);

        });
  }

  CoverViews() {

    try {
      let stHTML: string;
      let strTR: string;
      let Title: string;



      strTR = "";
      let objCoverDetails = this.objPremiumAndVehicleInfoRes.PREMIUM_INFO.CoverDetails;


      if (this.Lng == "en") {
        Title = "Cover Details";

        stHTML = "<div class='scrollDiv' style=' min-width: 80%;max-width: 100%;overflow: scroll;'><table id='table' class='table table-bordered table-responsive'> <thead><tr>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>SNO</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>COVER CODE</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>DESCRIPTION</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>GROSS_AMOUNT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>NCD_AMOUNT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>LD_AMOUNT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>DRIVER_DISCOUNT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>PROMO_DISCOUNT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>OTHER_DISCOUNT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>PRICE</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>VAT</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>RATE</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>TARRIF_ID</th>"

          + "</tr></thead><tbody>";

        for (let i = 0; i <= objCoverDetails.length - 1; i++) {
          strTR = strTR + "<tr>"

            // + "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].Sno + "</td>" +
            + "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + (i + 1).toString() + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].CoverCode + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].CoverDescription + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].GrossAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].NCDAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].LDAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].DriverDiscAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].PromoDiscAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].OtherDiscAmount+ objCoverDetails[i].UserDiscount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].TotalPrice + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].Vat_Amount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].Rate + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].TariffId + "</td>" +
            "</tr>";

        }
      }
      else {

        Title = "بيانات التغطية";

        stHTML = "<div class='scrollDiv' style=' min-width: 80%;max-width: 100%;overflow: scroll;'><table id='table' class='table table-bordered table-responsive'> <thead><tr>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>الرقم التسلسلي</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>الرمز</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap ; width:200px;'> الوصف</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>الاجمالي قبل الخصومات</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'> خصم عدم وجود مطالبات</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>مبلغ خصم الولاء</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>الخصم</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>قيمة الخصم الترويجي</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>الخصم</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>المبلغ الاجمالي</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>مبلغ ضريبة القيمة المضافة</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>RATE</th>"
          + "<th style='padding: 2px 5px;font-size: 13px;color: #266aab;font-weight: 500;white-space:nowrap'>TARRIF_ID</th>"

          + "</tr></thead><tbody>";

        for (let i = 0; i <= objCoverDetails.length - 1; i++) {
          strTR = strTR + "<tr>"

            // + "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].Sno + "</td>" +
            + "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + (i + 1).toString() + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].CoverCode + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black; width:200px;'>" + objCoverDetails[i].CoverDescription_Ar + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].GrossAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].NCDAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].LDAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].DriverDiscAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].PromoDiscAmount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].OtherDiscAmount+ objCoverDetails[i].UserDiscount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].TotalPrice + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].Vat_Amount + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].Rate + "</td>" +
            "<td style='border: 1px solid #eceeef;padding: 2px 4px;font-size: 12px;font-weight: 600;color: black;'>" + objCoverDetails[i].TariffId + "</td>" +
            "</tr>";

        }

      }

      stHTML = stHTML + strTR + "</tbody></table></div>";

      Swal({
        title: Title,//' Cover Details ',
        html: stHTML,
        type: "info",
        background: 'white',
        customClass: 'swal-wide !important',
        width: '90%',
      });



    }
    catch
    { }
  }


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalPremiumInfo/CompRenewalPremiumInfo.ts